import { render, staticRenderFns } from "./PageLoginTwitter.vue?vue&type=template&id=a0986cfe&"
import script from "./PageLoginTwitter.vue?vue&type=script&lang=ts&"
export * from "./PageLoginTwitter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports